export default {
  'channelReseller.title': 'Resellers',
  'channelReseller.description':
    'Register reseller entities with optional distributor or partner parent.',

  'channelReseller.columns.billingResponsibility': 'Billing responsibility',

  'resellerBillingResponsibility.customerPaysAutomyStripe': 'Customer pays (Automy Stripe)',
  'resellerBillingResponsibility.resellerPaysAutomy': 'Reseller pays Automy',
  'resellerBillingResponsibility.manual': 'Manual',
};
